import { IconDashboard, IconFileAlert, IconMathFunction, IconUsers } from '@tabler/icons';

// constant
const icons = {
    IconDashboard,
    IconMathFunction,
    IconFileAlert,
    IconUsers
};

// ==============================|| DASHBOARD PAGE & MENU ITEMS ||============================== //

const configuration = {
    id: 'configuration',
    title: 'CONFIGURATION',
    type: 'group',
    children: [
        {
            id: 'users',
            title: 'USERS',
            type: 'item',
            url: '/configuration/users',
            icon: icons.IconUsers,
            breadcrumbs: false
        },
        {
            id: 'edit-params',
            title: 'PARAMS',
            type: 'item',
            url: '/configuration/edit-params',
            icon: icons.IconMathFunction,
            breadcrumbs: false
        },
        {
            id: 'edit-attention-classes',
            title: 'ATTENTION_CLASSES',
            type: 'item',
            url: '/configuration/edit-attention-classes',
            icon: icons.IconFileAlert,
            breadcrumbs: false
        }
    ]
};

export default configuration;
